import React from "react";
import { Card, Progress } from "@payping/web-components";
import { useNavigate } from "react-router-dom";
import { webConstants } from "@payping/utils/platformConstants";

import { useAppTranslation } from "@/utils/useAppTranslation";
import { profileCompletionId } from "@/assets/googleTrackIds";
import styles from "@/assets/scss/SummationTab.module.scss";

const ProfileCompletion: React.FC<{ checksPercent?: number }> = ({ checksPercent }) => {
  // =========================================
  // Init
  // =========================================
  const { t } = useAppTranslation();
  const navigate = useNavigate();

  // =========================================
  // Handler
  // =========================================
  const onClick = (): void => {
    const url = webConstants.DashboardRoutes.user.profile.root;
    navigate(url);
  };

  // =========================================
  // Render
  // =========================================
  return (
    <Card.Raw clickable onClick={onClick} data-google-track={profileCompletionId}>
      <Card.Raw.ColMeta header={<Card.Raw.RowMeta title={t("overview.profileCompletion")} />}>
        <Progress
          strokeColor={{ from: "#108ee9", to: "#87d068" }}
          percent={checksPercent}
          status={checksPercent !== 100 ? "active" : "normal"}
          className={styles.profileCompletionProgress}
          strokeWidth={15}
        />
      </Card.Raw.ColMeta>
    </Card.Raw>
  );
};

export default ProfileCompletion;
